// pages/redemptions.js
import React, { useState } from 'react';
import Sidebar from '../components/sidebar';
import RedemptionsTable from '../components/redemptionsTable';
import NewRedemptionModal from '../components/newRedemptionModal';

function Redemptions() {
  const [showModal, setShowModal] = useState(false);

  const handleNewRedemption = () => {
    setShowModal(true);
  };

  return (
    <div className="kmint container-fluid">
      <div className="row">
        <Sidebar />
        <main className="kmint col-md-6 ms-sm-auto col-lg-6 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2">Redemptions</h1>
            <div className="btn-toolbar mb-2 mb-md-0">
              <button type="button" className="btn btn-md btn-outline-secondary me-2">
                Export CSV
              </button>
              <button type="button" className="btn btn-md btn-kmint-blue" onClick={handleNewRedemption}>
                New Redemption
              </button>
            </div>
          </div>
          <RedemptionsTable />
          <NewRedemptionModal show={showModal} onHide={() => setShowModal(false)} />
        </main>
        <div className='col-md-3'></div>
      </div>
    </div>
  );
}

export default Redemptions;